import { C as CosmosTitle$1, d as defineCustomElement$1 } from './p-Dgnmlsje.js';

const CosmosTitle = CosmosTitle$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosTitle, defineCustomElement };
